<template>
  <FormModal :data="data" :endpoint="endpoint" method="PUT" title="Edit Host Agency" v-bind="$attrs" @success="success">
    <InputGroup label="Name" name="name">
      <TextInput v-model="data.name" />
    </InputGroup>

    <InputGroup label="Slug" name="slug">
      <TextInput v-model="data.slug" />
    </InputGroup>

    <InputGroup label="Logo" name="logo">
      <ImageInput v-model="data.logo" />
    </InputGroup>

    <Alert v-if="data.slug !== originalSlug" type="danger">
      <p>
        <strong>Warning:</strong> Changing the slug will break all existing links to this host agency, resulting in
        broken analytics etc. Only change the slug if the host agency hasn't been used yet.
      </p>
    </Alert>
  </FormModal>
</template>

<script>
import { Alert } from "@syntax51/app-kit"

export default {
  components: {
    Alert
  },
  props: {
    endpoint: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: true,
    data: {
      name: null,
      slug: null,
      logo: null
    },
    originalSlug: null
  }),
  async created() {
    const { data } = await this.$api.get(this.endpoint)
    this.data.name = data.data.name
    this.data.slug = data.data.slug
    this.data.logo = data.data.logo
    this.originalSlug = data.data.slug
    this.loading = false
  },
  methods: {
    success(result) {
      this.$notification.success(`Host agency **${this.data.name}** successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
